import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import {
  profileTagBase,
  ProfileIcon as BaseProfileIcon,
  ProfileIconUser as BaseProfileIconUser,
} from 'shiftNotes/styles/ProfileTag.style';

export const Container = styled('span')`
  position: relative;
  display: inline-block;
  z-index: 10;
`;

export const Trigger = styled('span')<{ $isOpen: boolean }>`
  ${profileTagBase}
  user-select: none;
  position: relative;

  &:hover {
    opacity: 0.8;
  }
`;

export const ProfileIcon = BaseProfileIcon;

export const ProfileIconUser = BaseProfileIconUser;

export const ChevronIcon = styled('span')<{ $isOpen: boolean }>`
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s ease;
  color: ${colours.blue[500]};
  margin-left: 2px;

  svg path {
    stroke: ${colours.blue[500]};
  }

  ${({ $isOpen }) =>
    $isOpen &&
    `
    transform: rotate(180deg);
  `}
`;

export const DropdownMenu = styled('div')`
  position: fixed;
  display: flex;
  width: 298px;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 35px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: white;
  box-shadow: 0 50px 70px -35px rgba(0, 0, 0, 0.15);
  z-index: 10000;
`;

export const SearchContainer = styled('div')`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
`;

export const SearchInput = styled('input')`
  display: flex;
  padding: 15px 20px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 30px;
  border: 2px solid ${colours.neutral[100]};
  width: 100%;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: black;
  background-color: white;
  outline: none;
  transition: border-color 0.15s ease;

  &::placeholder {
    color: ${colours.neutral[500]};
  }

  &:focus {
    border-color: ${colours.neutral[300]};
  }
`;

export const SearchIcon = styled('span')`
  position: absolute;
  right: 20px;
  display: flex;
  align-items: center;
  color: ${colours.neutral[500]};
  pointer-events: none;

  svg {
    stroke-width: 2;
  }
`;

export const OptionsList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
`;

export const Left = styled('span')`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const Avatar = styled('div')`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${colours.neutral[100]};
  display: flex;
  align-items: center;
  color: #001d25;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  flex-shrink: 0;
`;

export const NameInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0px;
  flex: 1;
  min-width: 0;

  p {
    margin: 0;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const ProfileId = styled('span')`
  font-size: 12px;
  line-height: 16px;
  color: ${colours.neutral[500]};
  font-family: 'Inter', sans-serif;
`;

export const Option = styled('button')<{ $isSelected: boolean }>`
  border: 0;
  font: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  cursor: pointer;
  transition: background-color 0.15s ease;
  padding: 20px;
  border-radius: 20px;
  gap: 10px;
  width: 100%;
  text-align: left;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${colours.primary[500]};
    outline-offset: 2px;
  }

  ${({ $isSelected }) =>
    $isSelected
      ? `
    background: #001d25;

    ${NameInfo} {
      p {
        color: white;
      }
    }

    ${ProfileId} {
      color: white;
      opacity: 0.9;
    }
  `
      : `
    background-color: white;

    &:hover {
      background-color: ${colours.neutral[100]};
    }
  `}
`;

export { OptionCheck as SelectedIndicator } from 'theme/components/SelectionDropdown.style';
